export const shouldAutoplayImageSlider = ({ slideCount, reduceMotion }) => slideCount > 1 && !reduceMotion;

export const getImageSliderOptions = ({ slideCount, reduceMotion }) => ({
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: slideCount > 1,
    autoplay: shouldAutoplayImageSlider({ slideCount, reduceMotion })
        ? { delay: 5000, disableOnInteraction: false }
        : false,
    a11y: { enabled: true }
});

export const shouldRunImageSliderAutoplay = ({ userPaused, hovering }) => !userPaused && !hovering;

export const reduceImageSliderState = (state, action) => {
    switch (action.type) {
        case 'toggle':
            // An explicit start overrides a hover hold, as in the W3C carousel pattern.
            return state.userPaused ? { userPaused: false, hovering: false } : { ...state, userPaused: true };
        case 'pointerenter':
            return action.pointerType === 'mouse' ? { ...state, hovering: true } : state;
        case 'pointerleave':
            return action.pointerType === 'mouse' ? { ...state, hovering: false } : state;
        case 'focusin':
            return action.onToggle ? state : { ...state, userPaused: true };
        default:
            return state;
    }
};

export const getImageSliderToggleLabel = (paused) => paused ? 'Start autoplay' : 'Pause autoplay';
